import React from "react"
import classnames from "classnames"
import { ApiFetch } from "../Api"
import SearchMessage from "../search/SearchMessage"
import SearchResults from "../search/SearchResults"
import SearchResultsEmpty from "../search/SearchResultsEmpty"
import SearchResultsError from "../search/SearchResultsError"
import SearchResultsLoading from "../search/SearchResultsLoading"

const DEBOUNCE = 750
const CACHE = {}

export default class NavbarSearchBox extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      query: "",
      debouncedQuery: "",
      isOpen: false,
      isFocused: false
    }

    this.debounce = null
    this.inputRef = null
    this.dropdownRef = null
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
    if (this.debounce) {
      window.clearTimeout(this.debounce)
    }
  }

  componentDidUpdate() {
    const query = this.state.query.trim()

    if (this.state.debouncedQuery !== query) {
      if (this.debounce) {
        window.clearTimeout(this.debounce)
      }

      this.debounce = window.setTimeout(() => {
        this.setState({ debouncedQuery: query })
      }, DEBOUNCE)
    }
  }

  handleClickOutside = (event) => {
    if (this.dropdownRef && !this.dropdownRef.contains(event.target)) {
      this.setState({ isOpen: false, isFocused: false })
    }
  }

  handleInputChange = (event) => {
    const query = event.target.value
    this.setState({ 
      query,
      isOpen: query.length > 0,
      isFocused: true
    })
  }

  handleInputFocus = () => {
    this.setState({ 
      isFocused: true,
      isOpen: this.state.query.length > 0
    })
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const searchQuery = this.state.query.trim()
    
    if (searchQuery) {
      if (this.props.onSearch) {
        this.props.onSearch(searchQuery)
      } else {
        // Redirect to Misago's search page with query parameter
        const searchUrl = misago.get("SEARCH_URL")
        const searchWithQuery = searchUrl + "?q=" + encodeURIComponent(searchQuery)
        window.location.href = searchWithQuery
      }
      this.setState({ isOpen: false, isFocused: false })
    }
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.handleSubmit(event)
    } else if (event.key === 'Escape') {
      this.setState({ isOpen: false, isFocused: false })
      this.inputRef && this.inputRef.blur()
    }
  }

  getSearchUrl = (query) => {
    return misago.get("SEARCH_API") + "?q=" + encodeURIComponent(query)
  }

  render() {
    const { className, placeholder } = this.props
    const { query, debouncedQuery, isOpen, isFocused } = this.state

    return (
      <div className={classnames("navbar-search-box", className)} ref={(ref) => this.dropdownRef = ref}>
        <form onSubmit={this.handleSubmit} className="search-form">
          <div className="search-input-container">
            <span className="material-icon search-icon">search</span>
            <input
              ref={(ref) => this.inputRef = ref}
              type="text"
              name="search"
              className="form-control search-input"
              placeholder={placeholder || pgettext("navbar search", "Search...")}
              value={query}
              onChange={this.handleInputChange}
              onFocus={this.handleInputFocus}
              onKeyDown={this.handleKeyPress}
            />
          </div>
        </form>
        
        {isOpen && isFocused && (
          <div className="search-dropdown-results">
            <ApiFetch
              url={this.getSearchUrl(debouncedQuery)}
              cache={CACHE}
              disabled={debouncedQuery.length < 3}
            >
              {({ data, loading, error }) => {
                if (debouncedQuery.length < 3) {
                  return <SearchMessage />
                }

                if (loading) {
                  return <SearchResultsLoading />
                }

                if (error) {
                  return <SearchResultsError error={error} />
                }

                if (this.isResultEmpty(data)) {
                  return <SearchResultsEmpty />
                }

                if (data !== null) {
                  return <SearchResults query={debouncedQuery} results={data} />
                }

                return null
              }}
            </ApiFetch>
          </div>
        )}
      </div>
    )
  }

  isResultEmpty = (results) => {
    if (results === null) {
      return true
    }

    let resultsCount = 0
    results.forEach((result) => {
      resultsCount += result.results.count
    })
    return resultsCount === 0
  }
}